import { render } from "./BilletStatusPill.vue?vue&type=template&id=08b3770a"
import script from "./BilletStatusPill.vue?vue&type=script&lang=js"
export * from "./BilletStatusPill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__